export default __webpack_public_path__ + "static/media/miriam.35e7cbe0.png";